import { constants, Investment, InvestmentKey, queries } from 'procura-shared';
import { messagedCall, post } from '.';
import firebase from '../firebase';

export const updateInvestment = (investment: Investment): Promise<any> => {
  let newData = {};
  Object.keys(investment).forEach((key: InvestmentKey) => {
    if (constants.INVESTMENT_KEYS.includes(key)) {
      const value = investment[key];
      if (value == null && value === '') {
        newData = { ...newData, [key]: firebase.firestore.FieldValue.delete() };
      } else {
        newData = { ...newData, [key]: value };
      }
    }
  });
  if (Object.keys(newData).length === 0) return;
  return messagedCall(
    queries.investmentQuery(investment.id).update(newData),
    'updateInvestmentLoading',
    'updateInvestmentSuccess',
    'updateInvestmentError'
  );
};

export const updateShare = (investmentId: string, id: string, value: number) =>
  messagedCall(
    post('updateShare', { investmentId, id, value }),
    'updateInvestmentLoading',
    'updateInvestmentSuccess',
    'updateInvestmentError'
  );

export const updateRole = (investmentId: string, id: string, value: string | null) =>
  messagedCall(
    post('updateRole', { investmentId, id, value }),
    'updateInvestmentLoading',
    'updateInvestmentSuccess',
    'updateInvestmentError'
  );

export const deleteInvestment = (investmentId: string) =>
  messagedCall(
    post('deleteInvestment', { investmentId }),
    'deleteInvestmentLoading',
    'deleteInvestmentSuccess',
    'deleteInvestmentError'
  );

export const createInvestment = async (name: string) =>
  messagedCall(
    post('createInvestment', { name }),
    'createInvestmentLoading',
    'createInvestmentSuccess',
    'createInvestmentError'
  );

export const deleteDocument = (params: {
  investmentId: string;
  documentPath: string;
  documentName: string;
  documentUrl: string;
}) =>
  messagedCall(
    post('deleteDocument', { ...params }),
    'deleteDocumentLoading',
    'deleteDocumentSuccess',
    'deleteDocumentError'
  );
